import {
  UTILS_ADD_FORM_DATA,
  UTILS_DEV_RESET_ALL_DATA,
  UTILS_RESET_PERSISTENT_DATA,
} from 'src/app/shared/constants/dispatcherId';
import { STANDOUT_SELECTION_STORAGE_KEY } from 'src/app/shared/constants/storage';
import { resetTrackingStorage } from 'src/app/shared/dataAnalytics/storage';
import { reload } from 'src/app/utils/reload';
import { actionUpdateIsDataCleanupComplete } from 'src/app/v1/state/modules/app/isDataCleanupComplete';
import { actionUpdateAdvertiserId } from 'src/app/v1/state/modules/session/advertiserId';

import addFormData from './addFormData';
import resetAll from './resetAll';
import resetAppData from './resetAppData';
import resetFormData from './resetFormData';
import resetSession from './resetSession';
import resetTealium from './resetTealium';

export default (dispatcherId: string, obj?: any) => (dispatch: any) => {
  switch (dispatcherId) {
    case UTILS_DEV_RESET_ALL_DATA: {
      dispatch(resetAll());
      dispatch(actionUpdateAdvertiserId('0000'));
      sessionStorage.removeItem(STANDOUT_SELECTION_STORAGE_KEY);
      resetTrackingStorage();
      reload();
      return null;
    }

    case UTILS_ADD_FORM_DATA: {
      return dispatch(addFormData(obj));
    }

    case UTILS_RESET_PERSISTENT_DATA: {
      dispatch(resetAppData());
      dispatch(resetFormData());
      dispatch(resetSession());
      dispatch(resetTealium());
      sessionStorage.removeItem(STANDOUT_SELECTION_STORAGE_KEY);
      resetTrackingStorage();
      dispatch(actionUpdateIsDataCleanupComplete(true));
      return null;
    }

    default: {
      return null;
    }
  }
};
